<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Shift Name"
                  v-model="shiftInfo.name"
                  type="text"
                  :rules="[() => !!shiftInfo.name || 'Shift name is required',]"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  ref="menuStartTimeRef"
                  lazy
                  :close-on-content-click="false"
                  v-model="startHour"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                  :return-value.sync="time"
                >
                  <v-text-field
                    slot="activator"
                    label="Start Hour"
                    v-model="shiftInfo.startHour"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    v-model="shiftInfo.startHour"
                    format="24hr"
                    @change="$refs.menuStartTimeRef.save(shiftInfo.startHour)"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  ref="menuEndTimeRef"
                  lazy
                  :close-on-content-click="false"
                  v-model="endHour"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                  :return-value.sync="time"
                >
                  <v-text-field
                    slot="activator"
                    label="End Hour"
                    v-model="shiftInfo.endHour"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    v-model="shiftInfo.endHour"
                    format="24hr"
                    @change="$refs.menuEndTimeRef.save(shiftInfo.endHour)"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shiftInfo.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shiftInfo.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="shiftInfo.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="shiftInfo.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shiftInfo.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="shiftInfo.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex sm6 v-if="shiftInfo.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { shiftInfoService } from "../../services/shift-info-service";
import { ShiftInfo } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";

export default {
  name: "ShiftInfoDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Shift Info",
        disabled: false,
        to: "shift-infos"
      },
      {
        text: "Shift Info Detail",
        disabled: true
      }
    ],
    username: "",
    time: false,
    startHour: false,
    endHour: false,
    shiftInfo: new ShiftInfo(),
    oldShiftInfo: new ShiftInfo(),
    statusFlag: true,
    saveLoading: false,
    responseError: ""
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new shift info
    } else {
      this.getShiftInfoDetail(id);
    }
    let user = JSON.parse(localStorage.getItem("user"));
    this.shiftInfo.shopId = user.shopId;
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.shiftInfo.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let shiftInfoObj = {
          id: this.shiftInfo.id ? this.shiftInfo.id : "",
          name: this.shiftInfo.name,
          startHour: this.shiftInfo.startHour,
          endHour: this.shiftInfo.endHour,
          shopId: this.shiftInfo.shopId,
          status: this.shiftInfo.status
        };
        shiftInfoService
          .saveShiftInfo(shiftInfoObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getShiftInfoDetail(id) {
      shiftInfoService
        .getShiftInfoDetail(id)
        .then(res => {
          this.shiftInfo = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.shiftInfo.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.shiftInfo.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldShiftInfo = Object.assign({}, res.data);
          this.statusFlag = this.shiftInfo.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.shiftInfo.id) {
        this.shiftInfo = new ShiftInfo();
        this.statusFlag = true;
      } else {
        this.shiftInfo = Object.assign({}, this.oldShiftInfo);
        this.statusFlag = this.shiftInfo.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/shift-infos");
    }
  }
};
</script>

